import React from 'react';

function NoDataFound(props: any) {
  const { query, errorStatus, onReportClick } = props || {};

  const isServerError = errorStatus >= 500;

  return (
    <div className="bg-white rounded-xl flex flex-col justify-center items-center w-full h-[480px] p-10">
      <img src="solar_card-search-linear_icon.png" alt="No data found" />
      <p className="font-normal text-sm font-primary mt-4 text-center">
        {isServerError ? (
          <>
            A server error occurred. Please try again later or{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onReportClick?.(); // Call parent handler
              }}
              className="text-blue-600 underline"
            >
              contact support by clicking here
            </a>.
          </>
        ) : (
          query || 'No results found'
        )}
      </p>
    </div>
  );
}

export default NoDataFound;
